import { SheetColumnType } from 'webapp/enums/enums';

import CustomQuerySetupWizardSheetStepCommonComponent from 'webapp/components/custom-query/setup/wizard/sheet/step-common';

export default class CustomQuerySetupWizardSheetStepDateComponent extends CustomQuerySetupWizardSheetStepCommonComponent {
	override stepTitle = 'Select date';
	override stepDescription =
		'Confirm the column holding your date (timestamp) information. If you don’t have a date column, or prefer to use the current date & time for each value, select ‘Use current time of storing data’ below.';
	override optionNoneLabel = 'Use current time of storing data <span>(Dynamic)</span>';

	override get isNoneDisabled(): boolean {
		// disable no date option if no dimension is selected
		const dimensionField = this.args.form.getA1FieldForType(SheetColumnType.DIMENSION);
		return !!dimensionField && !dimensionField.value;
	}

	override get noneDisabledText(): string {
		return this.isNoneDisabled ? 'Either date or dimension column is required.' : '';
	}
}
